module.exports = __webpack_public_path__ + "img/DE00418.c129c6a8.png";